import { ProviderMessage } from '@enter/core';
import { ProviderMessagingContext, IProviderMessagingContextProps } from '../messaging/messaging.context';
import React, { useContext } from 'react';
import * as S from './alert-bar.styles';

export interface IAlertBarProps {
    className?: string;
    messages?: ProviderMessage[];
    claimId: string;
    onDismiss: () => void;
}
export const AlertBar: React.FunctionComponent<IAlertBarProps> = (props: IAlertBarProps): React.ReactElement => {
    const messagingContext = useContext(ProviderMessagingContext) as IProviderMessagingContextProps;
    const { className, messages, claimId, onDismiss } = props;
    const handleClick = (): void => {
        onDismiss();
    };

    const handleOpenMessage = (messageId?: string) => () => {
        messagingContext.openPanel?.({ claimId, messageId });
    };

    if (messages && messages.length) {
        return (
            <S.Alert className={className}>
                <S.AlertRow>
                    {messages.length === 1 && (
                        <S.AlertMessage>
                            There is (1) message in you inbox regarding this claim.{' '}
                            <S.AlertLinkButton variant="text" onClick={handleOpenMessage(messages[0].id!)}>
                                Click here to review.
                            </S.AlertLinkButton>
                        </S.AlertMessage>
                    )}
                    {messages.length > 1 && (
                        <S.AlertMessage>
                            {messages.length > 1 &&
                                `There are (${messages.length}) messages in you inbox regarding this claim.`}
                            <S.AlertLinkButton variant="text" onClick={handleOpenMessage()}>
                                Click here to review.
                            </S.AlertLinkButton>
                        </S.AlertMessage>
                    )}
                    <S.AlertButton variant="outlined" onClick={handleClick}>
                        Dismiss
                    </S.AlertButton>
                </S.AlertRow>
            </S.Alert>
        );
    }
    return <></>;
};
